const trustItems = [
  { icon: 'ri-award-line', label: 'Licensed Inspectors' },
  { icon: 'ri-map-pin-2-line', label: 'Greater Houston Area' },
  { icon: 'ri-calendar-check-line', label: 'Fast Scheduling' },
  { icon: 'ri-file-text-line', label: 'Digital Reports' },
];

export default function TrustBar() {
  return (
    <section className="bg-[#1A1A1A] py-5">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="flex flex-wrap justify-center md:justify-between items-center gap-6 md:gap-0">
          {trustItems.map((item, i) => (
            <div key={i} className="flex items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className={`${item.icon} text-[#C9A961] text-base`}></i>
              </div>
              <span className="text-white/80 text-sm font-medium tracking-wide whitespace-nowrap">
                {item.label}
              </span>
              {i < trustItems.length - 1 && (
                <div className="hidden md:block w-px h-4 bg-white/15 ml-6"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
